module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.formReady) ? _c('b-card', {
    staticClass: "mainCardBG animate__animated animate__fadeIn",
    attrs: {
      "title": _vm.$route.name
    }
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "mb-3",
    staticStyle: {
      "border-radius": "5px !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("\n              Back\n            ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("\n            " + _vm._s(_vm.formData.JobNo || 'No Job No') + "\n            "), (_vm.formData.air_ct_shipping_bl_no && _vm.formData.air_ct_shipping_bl_date && _vm.formData.air_ct_shipper_inv_no && _vm.formData.air_ct_shipper_inv_date && _vm.formData.air_ct_cargo_gross_weight && _vm.formData.air_ct_cargo_net_weight && _vm.formData.air_ct_clearance_date && _vm.formData.air_ct_handover_date) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": _vm.proceedToTally
    }
  }, [_vm._v("Proceed To Invoice")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.formData.fk_all_module_id ? _vm.formData.fk_all_module_id : '',
      "jobSeriesBanner": _vm.formData.air_ct_job_no ?
        _vm.formData.air_ct_job_no :
        '',
      "bannerClientName": _vm.formData.ClientName ? _vm.formData.ClientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Shipment Type",
      "label-for": "shipmentType"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "shipmentType",
      "value": _vm.formData.air_ct_shipment_type_Txt,
      "readonly": true
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_shipment_type_Txt) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_shipment_type_Txt))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Job Type (CC,TPT,FF)",
      "label-for": "jobType"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "jobType",
      "value": _vm.formData.air_ct_job_type,
      "readonly": true
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_job_type) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_job_type))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Job Number",
      "label-for": "jobNo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "jobNo",
      "readonly": true
    },
    model: {
      value: (_vm.formData.JobNo),
      callback: function($$v) {
        _vm.$set(_vm.formData, "JobNo", $$v)
      },
      expression: "formData.JobNo"
    }
  })], 1), _vm._v(" "), (!_vm.formData.JobNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.JobNo))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Client",
      "label-for": "ClientName"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "ClientName",
      "value": _vm.formData.ClientName,
      "readonly": true
    }
  })], 1), _vm._v(" "), (!_vm.formData.ClientName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.ClientName))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Airline",
      "label-for": "airlineName"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "airlineName",
      "readonly": true
    },
    model: {
      value: (_vm.formData.Airline),
      callback: function($$v) {
        _vm.$set(_vm.formData, "Airline", $$v)
      },
      expression: "formData.Airline"
    }
  })], 1), _vm._v(" "), (!_vm.formData.Airline) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.Airline))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Departure Airport",
      "label-for": "departureAirport"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "departureAirport",
      "readonly": true
    },
    model: {
      value: (_vm.formData.Departure),
      callback: function($$v) {
        _vm.$set(_vm.formData, "Departure", $$v)
      },
      expression: "formData.Departure"
    }
  })], 1), _vm._v(" "), (!_vm.formData.Departure) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.Departure))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Destination Airport",
      "label-for": "destinationAirport"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "destinationAirport",
      "readonly": true
    },
    model: {
      value: (_vm.formData.Destination),
      callback: function($$v) {
        _vm.$set(_vm.formData, "Destination", $$v)
      },
      expression: "formData.Destination"
    }
  })], 1), _vm._v(" "), (!_vm.formData.Destination) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.Destination))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Flight No",
      "label-for": "flightNo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "flightNo"
    },
    model: {
      value: (_vm.formData.air_ct_flight_no),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_flight_no", $$v)
      },
      expression: "formData.air_ct_flight_no"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_flight_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_flight_no))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Booking No",
      "label-for": "bookingNo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "bookingNo"
    },
    model: {
      value: (_vm.formData.booking_no),
      callback: function($$v) {
        _vm.$set(_vm.formData, "booking_no", $$v)
      },
      expression: "formData.booking_no"
    }
  })], 1), _vm._v(" "), (!_vm.formData.booking_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.booking_no))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "AWB BL Number",
      "label-for": "mawbNo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "awbNo"
    },
    model: {
      value: (_vm.formData.air_ct_awb_bl_number),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_awb_bl_number", $$v)
      },
      expression: "formData.air_ct_awb_bl_number"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_awb_bl_number) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_awb_bl_number))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "MAWB BL Number",
      "label-for": "mawbNo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "mawbNo"
    },
    model: {
      value: (_vm.formData.air_ct_mawb_bl_number),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_mawb_bl_number", $$v)
      },
      expression: "formData.air_ct_mawb_bl_number"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_mawb_bl_number) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_mawb_bl_number))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Shipping BL No",
      "label-for": "shippingBlNo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "shippingBlNo"
    },
    model: {
      value: (_vm.formData.air_ct_shipping_bl_no),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_shipping_bl_no", $$v)
      },
      expression: "formData.air_ct_shipping_bl_no"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_shipping_bl_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_shipping_bl_no))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Shipper Inv No",
      "label-for": "shipperInvNo"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "shipperInvNo"
    },
    model: {
      value: (_vm.formData.air_ct_shipper_inv_no),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_shipper_inv_no", $$v)
      },
      expression: "formData.air_ct_shipper_inv_no"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_shipper_inv_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_shipper_inv_no))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Gross Weight",
      "label-for": "grossWeight"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "grossWeight",
      "type": "number"
    },
    model: {
      value: (_vm.formData.air_ct_cargo_gross_weight),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_cargo_gross_weight", $$v)
      },
      expression: "formData.air_ct_cargo_gross_weight"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_cargo_gross_weight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_cargo_gross_weight))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Net Weight",
      "label-for": "netWeight"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "netWeight",
      "type": "number"
    },
    model: {
      value: (_vm.formData.air_ct_cargo_net_weight),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_cargo_net_weight", $$v)
      },
      expression: "formData.air_ct_cargo_net_weight"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_cargo_net_weight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_cargo_net_weight))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Volume Weight",
      "label-for": "volumeWeight"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "volumeWeight",
      "type": "text"
    },
    model: {
      value: (_vm.formData.air_ct_cargo_volume_weight),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_cargo_volume_weight", $$v)
      },
      expression: "formData.air_ct_cargo_volume_weight"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_cargo_volume_weight) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_cargo_volume_weight))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cargo Unit",
      "label-for": "cargoUnit"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "cargoUnit",
      "options": ['Kg', 'LBS', 'Others']
    },
    model: {
      value: (_vm.formData.air_ct_cargo_unit),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_cargo_unit", $$v)
      },
      expression: "formData.air_ct_cargo_unit"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_cargo_unit) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_cargo_unit))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Chargeable Wgt (Sys)",
      "label-for": "chargeSys"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "chargeSys",
      "type": "number"
    },
    model: {
      value: (_vm.formData.air_ct_chargeable_weight_by_sys),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_chargeable_weight_by_sys", $$v)
      },
      expression: "formData.air_ct_chargeable_weight_by_sys"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_chargeable_weight_by_sys) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_chargeable_weight_by_sys))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Chargeable Wgt (Airline)",
      "label-for": "chargeAirline"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "chargeAirline",
      "type": "number"
    },
    model: {
      value: (_vm.formData.air_ct_chargeable_weight_by_airline),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_chargeable_weight_by_airline", $$v)
      },
      expression: "formData.air_ct_chargeable_weight_by_airline"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_chargeable_weight_by_airline) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_chargeable_weight_by_airline))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Final Chargeable Wgt",
      "label-for": "chargeFinal"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "chargeFinal",
      "type": "number"
    },
    model: {
      value: (_vm.formData.air_ct_chargeable_weight_final),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_chargeable_weight_final", $$v)
      },
      expression: "formData.air_ct_chargeable_weight_final"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_chargeable_weight_final) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_chargeable_weight_final))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Shipping BL Date",
      "label-for": "shippingBlDate"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "shippingBlDateObj",
      "name": "shippingBlDateObj"
    },
    model: {
      value: (_vm.formData.air_ct_shipping_bl_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_shipping_bl_date", $$v)
      },
      expression: "formData.air_ct_shipping_bl_date"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_shipping_bl_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_shipping_bl_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Shipper Inv Date",
      "label-for": "shipperInvDate"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "shipperInvDate",
      "name": "shipperInvDateObj"
    },
    model: {
      value: (_vm.formData.air_ct_shipper_inv_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_shipper_inv_date", $$v)
      },
      expression: "formData.air_ct_shipper_inv_date"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_shipper_inv_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_shipper_inv_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Clearance Date",
      "label-for": "clearanceDate"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "clearanceDate",
      "name": "clearanceDateObj"
    },
    model: {
      value: (_vm.formData.air_ct_clearance_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_clearance_date", $$v)
      },
      expression: "formData.air_ct_clearance_date"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_clearance_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_clearance_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Handover Date",
      "label-for": "handoverDate"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "handoverDate",
      "name": "handoverDateObj"
    },
    model: {
      value: (_vm.formData.air_ct_handover_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_handover_date", $$v)
      },
      expression: "formData.air_ct_handover_date"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_handover_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_handover_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Actual Departure",
      "label-for": "actualDepartureDate"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "actualDepartureDate",
      "name": "actualDepartureDateObj"
    },
    model: {
      value: (_vm.formData.air_ct_actual_departure_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_actual_departure_date", $$v)
      },
      expression: "formData.air_ct_actual_departure_date"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_actual_departure_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_actual_departure_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Actual Arrival",
      "label-for": "actualArrivalDate"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "actualArrivalDate",
      "name": "actualArrivalDateObj"
    },
    model: {
      value: (_vm.formData.air_ct_actual_arrival_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_actual_arrival_date", $$v)
      },
      expression: "formData.air_ct_actual_arrival_date"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_actual_arrival_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_actual_arrival_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Expected Departure",
      "label-for": "expectedDepartureDate"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "expectedDepartureDate",
      "name": "expectedDepartureDateObj"
    },
    model: {
      value: (_vm.formData.air_ct_expected_departure_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_expected_departure_date", $$v)
      },
      expression: "formData.air_ct_expected_departure_date"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_expected_departure_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_expected_departure_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Expected Arrival",
      "label-for": "expectedArrivalDate"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "expectedArrivalDate",
      "name": "expectedArrivalDateObj"
    },
    model: {
      value: (_vm.formData.air_ct_expected_arrival_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_expected_arrival_date", $$v)
      },
      expression: "formData.air_ct_expected_arrival_date"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_expected_arrival_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_expected_arrival_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Flight Date",
      "label-for": "air_ct_flight_date"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "air_ct_flight_date",
      "name": "air_ct_flight_date"
    },
    model: {
      value: (_vm.formData.air_ct_flight_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_flight_date", $$v)
      },
      expression: "formData.air_ct_flight_date"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_flight_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_flight_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "MAWB Date",
      "label-for": "air_ct_mawb_bl_date"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "air_ct_mawb_bl_date",
      "name": "air_ct_mawb_bl_date"
    },
    model: {
      value: (_vm.formData.air_ct_mawb_bl_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_mawb_bl_date", $$v)
      },
      expression: "formData.air_ct_mawb_bl_date"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_mawb_bl_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_mawb_bl_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "AWB Date",
      "label-for": "air_ct_awb_bl_date"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "air_ct_awb_bl_date",
      "name": "air_ct_awb_bl_date"
    },
    model: {
      value: (_vm.formData.air_ct_awb_bl_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "air_ct_awb_bl_date", $$v)
      },
      expression: "formData.air_ct_awb_bl_date"
    }
  })], 1), _vm._v(" "), (!_vm.formData.air_ct_awb_bl_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.air_ct_awb_bl_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3",
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Booking Date",
      "label-for": "booking_date"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "booking_date",
      "name": "booking_date"
    },
    model: {
      value: (_vm.formData.booking_date),
      callback: function($$v) {
        _vm.$set(_vm.formData, "booking_date", $$v)
      },
      expression: "formData.booking_date"
    }
  })], 1), _vm._v(" "), (!_vm.formData.booking_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.booking_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "type": "submit",
      "variant": "success"
    }
  }, [_vm._v("\n                    Save Changes\n                  ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-594c5e30","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/airFreight/airCCTPTConsol.vue
// module id = 2658
// module chunks = 0